import { PROPERTY_STRATEGIES_NAME, PROPERTY_TYPES } from '@constants';
class PropertySuggestion {
    id;
    name;
    marketType;
    type;
    thumbnailURL;
    createdAt;
    investmentStrategy;
    address;
    developer;
    leaseholders;
    bricks;
    capitalGain;
    annualLeasingPerBrick;
    annualProfits;
    capRate;
    occupancyPercentage;
    progress;
    stabilizationDate;
    latestRentDispersion;
    constructor(propertySuggestion) {
        this.id = propertySuggestion.id;
        this.name = propertySuggestion.name;
        this.marketType = propertySuggestion.marketType;
        this.type = propertySuggestion.type;
        this.thumbnailURL = propertySuggestion.thumbnailURL;
        this.createdAt = propertySuggestion.createdAt;
        this.investmentStrategy = propertySuggestion.investmentStrategy;
        this.address = propertySuggestion.address;
        this.developer = propertySuggestion.developer;
        this.leaseholders = propertySuggestion.leaseholders;
        this.bricks = propertySuggestion.bricks;
        this.capitalGain = propertySuggestion.capitalGain;
        this.annualLeasingPerBrick = propertySuggestion.annualLeasingPerBrick;
        this.annualProfits = propertySuggestion.annualProfits;
        this.capRate = propertySuggestion.capRate;
        this.occupancyPercentage = propertySuggestion.occupancyPercentage;
        this.progress = propertySuggestion.progress;
        this.stabilizationDate = propertySuggestion.stabilizationDate;
        this.latestRentDispersion = propertySuggestion.latestRentDispersion;
    }
    getStrategyName() {
        return PROPERTY_STRATEGIES_NAME[this.investmentStrategy];
    }
    getPropertyTypeName() {
        return PROPERTY_TYPES[this.type];
    }
    hasPresaleDiscounts() {
        return Boolean(this.bricks.prices.presale?.discountPercent > 0);
    }
    hasLastBricks() {
        return Boolean(this.bricks.onSale.count > 0 && this.bricks.onSale.count < 1000);
    }
}
export default PropertySuggestion;
